import React, { Component } from 'react';

import Select from 'react-select';

import Dialog from '../../../commonModules/interface/Dialog';
import PopUp from '../../../commonModules/interface/PopUp';
import { Grid } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';

class FormNewRole extends Component {

    render() {
        return (
            <PopUp 
                title="Ajouter un Type d'Utilisateur"
                block={true}
                close={this.props.handleClose}
                submitAction={this.props.handleSubmit}
                maxWidth="sm"
            >
            
                <Grid container >
                    {/* <div className={"form-group col-sm-12 "+(this.props.errors.roleName ? "has-error" : "")}>
                        <div className="fg-line ">
                        <label className="control-label">Nom du groupe</label>
                            <input type="text" id="roleName" className="form-control input-sm" onChange={this.props.handleChange} value={this.props.roleName} name="roleName" />
                            <small className="help-block">{this.props.errors.roleName}</small>
                            </div>
                        </div> */}
                        <Grid item xs={12}>
                            <InputText 
                                type="text" 
                                id="roleName" 
                                onChange={this.props.handleChange} 
                                value={this.props.roleName} 
                                name="roleName" 
                                label="Nom du Groupe" 
                                error={this.props.errors.roleName} 
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputSelectMagasin
                                value={this.props.pages}
                                onChange={pages => this.props.handleSelectPage(pages)}
                                options={this.props.pageSelect}
                                isMulti
                                error={this.props.errors.pages}
                                label="Accès pages"
                                // closeMenuOnSelect={false}
                                // closeOnSelect={false}
                                // components={makeAnimated()}
                                
                            />
                            {/* <div className={"form-group col-sm-12 "+(this.props.errors.pages ? "has-error" : "")}>
                                <label className="control-label">Accès Pages</label>  
                                <Select
                                    value={this.props.pages}
                                    onChange={pages => this.props.handleSelectPage(pages)}
                                    options={this.props.pageSelect}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    closeOnSelect={false}
                                    components={makeAnimated()}
                                    
                                />
                                <small className="help-block">{this.props.errors.pages}</small>
                            </div>                                                 */}
                        </Grid>
                </Grid>
            </PopUp>
                    
        );
    }
}

export default FormNewRole;